import { ColumnProps } from "antd/lib/table";
import { RequestHistory, RequestHistoryFilter } from "models/RequestHistory";
import React from "react";
import { useTranslation } from "react-i18next";
import { LayoutCell, LayoutHeader, OneLineText } from "react3l-ui-library";
import nameof from "ts-nameof.macro";
import { filterService } from "services/page-services/filter-service";
import { Moment } from "moment";
import { formatDate } from "helpers/date-time";
import {
  MENU_REPORT_HISTORY_PREVIEW_ROUTE,
  RESPONSIBILITY_HISTORY_DETAIL_ROUTE,
} from "config/route-consts";
import { OrderType } from "react3l-common";
import { requestHistoryService } from "services/page-services/request-history-service";
import { useHistory } from "react-router-dom";
import { View24 } from "@carbon/icons-react";
import { menuReportRepository } from "repositories/menu-report-repository";

export function useMenuReportHistoryList() {
  const [translate] = useTranslation();

  const { modelFilter: filter, dispatchFilter } = filterService.useModelFilter(
    RequestHistoryFilter,
    {
      orderBy: "savedAt",
      orderType: OrderType.DESC,
    }
  );

  const { requestHistoryList, requestHistoryCount, handlePagination } =
    requestHistoryService.useHistoryRequestList<
      RequestHistory,
      RequestHistoryFilter
    >(
      menuReportRepository.listRequestHistory,
      menuReportRepository.countRequestHistory,
      filter,
      dispatchFilter,
      RESPONSIBILITY_HISTORY_DETAIL_ROUTE,
      "versionId"
    );

  const history = useHistory();
  const handleGoBack = React.useCallback(() => {
    history.goBack();
  }, [history]);

  const previewHistory = React.useCallback(
    (requestHistory: any) => {
      history.replace(
        `${MENU_REPORT_HISTORY_PREVIEW_ROUTE}?versionId=${requestHistory?.versionId}`
      );
    },
    [history]
  );

  const columns: ColumnProps<any>[] = React.useMemo(
    () => [
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.histories.appUser")}
          />
        ),
        key: nameof("actor"),
        dataIndex: nameof("actor"),
        ellipsis: true,
        render(actor: string) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText value={actor} />
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.histories.action")}
          />
        ),
        key: nameof("actionName"),
        dataIndex: nameof("actionName"),
        ellipsis: true,
        render(actionName: string) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText value={actionName} />
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.histories.savedAt")}
          />
        ),
        key: nameof("savedAt"),
        dataIndex: nameof("savedAt"),
        ellipsis: true,
        render(...params: [Moment, RequestHistory, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText value={formatDate(params[0])} />
            </LayoutCell>
          );
        },
      },

      {
        title: (
          <LayoutHeader orderType="left" title={translate("general.action")} />
        ),
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 110,
        render(id: number, requestHistory: RequestHistory, index: number) {
          return (
            <div className="d-flex button-action-table missions-dxg">
              <div className="d-flex">
                <div className="enable-dxg">
                  <View24
                    className="btn-missions-green"
                    onClick={() => previewHistory(requestHistory)}
                  />
                </div>
              </div>
            </div>
          );
        },
      },
    ],
    [translate, previewHistory]
  );
  return {
    translate,
    handleGoBack,
    handlePagination,
    requestHistoryList,
    requestHistoryCount,
    columns,
    filter,
  };
}
